var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOutline11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 2C6.84315 2 5.5 3.34315 5.5 5V19C5.5 20.6569 6.84315 22 8.5 22H15.5C17.1569 22 18.5 20.6569 18.5 19V5C18.5 3.34315 17.1569 2 15.5 2H8.5ZM7.5 5C7.5 4.44772 7.94772 4 8.5 4H15.5C16.0523 4 16.5 4.44772 16.5 5V19C16.5 19.5523 16.0523 20 15.5 20H8.5C7.94772 20 7.5 19.5523 7.5 19V5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutline11);
export default __webpack_public_path__ + "static/media/phone_outline (1) (1).8ad09291653c15c004a0f731cec3166a.svg";
export { ForwardRef as ReactComponent };